/* eslint-disable react-hooks/exhaustive-deps */
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import { Grid } from '@mui/material';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import React, { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import MDBackdrop from "components/MDBackdrop";
import PopAddLocation from "./PopAddLocation";
import { useSnackbar } from "notistack";
import CloseIcon from '@mui/icons-material/Close';
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import { State, City } from 'country-state-city';
import FormLabel from '@mui/material/FormLabel';
import LocationPicker from "./components/LocationPicker";
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Button, Switch } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Image, Upload } from 'antd';
import { Flex, TimePicker } from 'antd';
import { TextField, InputAdornment } from "@mui/material";
import './Somecss.css';
import { allowDubaiAddress } from "utils/Constant";

const { RangePicker } = TimePicker;

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
function PopAddBasic(props) {
    const [isDialogOpen, setIsDialogOpen] = useState(props.isDialog);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([]);
    const [timeRanges, setTimeRanges] = useState([
        { start: null, end: null },
    ]);


    const isOverlapping = (ranges, currentIndex, newStart, newEnd) => {
        return ranges.some((range, index) => {
            if (
                index === currentIndex ||
                !range.start ||
                !range.end
            )
                return false;

            return (
                newStart.isBefore(range.end) &&
                newEnd.isAfter(range.start)
            );
        });
    };

    const handlePreview = async (file) => {
        setIsBackdrop(false);
        setIsDialogOpen(false);
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
                color: 'grey'
            }}
            type="button"
        >
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );
    const handleUploadChange = ({ fileList: newFileList }) => setFileList(newFileList);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { sidenavColor } = controller;
    const [isDisabled, setIsDisabled] = useState(false);
    const [isBackdrop, setIsBackdrop] = useState(false);
    const { onClose } = props;
    const [states] = useState(State.getStatesOfCountry('AE'));
    const [cities, setCities] = useState([]);
    const currentLocation = JSON.parse(localStorage.getItem("Currentlocation"));
    const initialLocation = { lat: currentLocation?.lat, lng: currentLocation?.lng } || {};
    const [errors, setErrors] = useState({});


    const { enqueueSnackbar } = useSnackbar();
    const [values, setValues] = useState(props.value);
    const handleChange = (event) => {
        setValues((prevValues) => ({
            ...prevValues,
            [event.target.name]: event.target.value,
        }));
        if (errors.locationName) {
            setErrors((prev) => ({ ...prev, locationName: "" }));
        }
        if (errors.address) {
            setErrors((prev) => ({ ...prev, address: "" }));
        }
    };
    const handlePropChange = (updatedValues) => {
        setValues((prev) => ({
            ...prev,
            ...updatedValues,
        }));
    };
    const handleFreePaidChange = (event) => {
        setValues((prevValues) => {
            return {
                ...prevValues,
                "freepaid": {
                    ...prevValues["freepaid"],
                    "parking": event,
                },
            };
        });
    };
    const handleFreePaidChangeCharging = (event) => {
        setValues((prevValues) => {
            return {
                ...prevValues,
                "freepaid": {
                    ...prevValues["freepaid"],
                    "charging": event,
                },
            };
        });
    };

    const [selectAfterValue, setSelectAfterValue] = useState(process.env.REACT_APP_CURRENCYCODE);

    const [parkingCost, setParkingCost] = useState({
        amount: "",
        currency: process.env.REACT_APP_CURRENCYCODE,
    });


    const handleCurrencyChange = (event) => {
        const newCurrency = event.target.value;
        setSelectAfterValue(newCurrency);
        setParkingCost((prev) => ({
            ...prev,
            currency: newCurrency,
        }));
    };


    const handleAmountChange = (event) => {
        const newAmount = event.target.value;
        setParkingCost((prev) => ({
            ...prev,
            amount: newAmount,
        }));
    };

    const handleLocationChange = (location) => {
        setValues((prevValues) => ({
            ...prevValues,
            direction: location,
        }));
    };
    const handleRangeChange = (index, values) => {
        if (!values) return;

        const [start, end] = values;

        if (!start || !end) return;

        if (isOverlapping(timeRanges, index, start, end)) {
            enqueueSnackbar('Time ranges cannot overlap', { variant: 'error', autoHideDuration: 2000 });
            return;
        }

        const updated = [...timeRanges];
        updated[index] = { start, end };
        setTimeRanges(updated);
    };

    const addTimeSlot = () => {
        setTimeRanges([...timeRanges, { start: null, end: null }]);
    };

    const removeTimeSlot = (index) => {
        setTimeRanges(timeRanges.filter((_, i) => i !== index));
    };

    const buildPayload = () => {
        return timeRanges
            .filter((r) => r.start && r.end)
            .map((r) => ({
                enabled: true,
                startTime: r.start.format("HH:mm"),
                endTime: r.end.format("HH:mm"),
                timezone: "Asia/Dubai",
            }));
    };

    const handleWorkingHourSave = () => {
        const workingHr = buildPayload();

        setValues((prevValues) => ({
            ...prevValues,
            slots: workingHr,
        }));

        enqueueSnackbar("Working hours updated successfully", { variant: "success", autoHideDuration: 2000 });

    }

    const reset = (event) => {
        event.preventDefault();
        values.locationName = "";
        values.locationType = "";
        values.address = "";
        values.state = "";
        values.city = "";
        values.status = "";
        values.freepaid = {
            "parking": true,
            "charging": true
        };
        values.parkingCost = {
            amount: "",
            currency: process.env.REACT_APP_CURRENCYCODE
        };
        setParkingCost({
            amount: "",
            currency: process.env.REACT_APP_CURRENCYCODE,
        });
        setSelectAfterValue(process.env.REACT_APP_CURRENCYCODE);
        setFileList([]);
        setValues(props.value);
    }
    const handleClose = () => {
        onClose(false);
    };
    const isValidImage = (file) => {

        return file.type.startsWith('image/');
    };
    const pop = () => {

        const hasImages = Array.from(fileList).some(file => isValidImage(file));
        if (!hasImages) {

            return enqueueSnackbar('Please upload at least one location image!', { variant: 'error' });
        }
        if (!values.locationName || !values.locationType || !values.address || !values.state || !values.city || !values.status) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' })
        if (!values.direction.latitude || !values.direction.longitude) return enqueueSnackbar('Please Enter the location correctly !!!', { variant: 'error' })
        if (!values.freepaid.parking && parkingCost.amount === '') {
            return enqueueSnackbar('Parking Amount is necessary when selected paid parking.', { variant: 'error' });
        }

        if (!allowDubaiAddress(values.locationName)) {

            return enqueueSnackbar("Invalid Location Name: Only letters, numbers, spaces and , / - . # ( ) ' are allowed"
                , { variant: "error" });
        }
        if (!allowDubaiAddress(values.address)) {

            return enqueueSnackbar("Invalid Address : Only letters, numbers, spaces and , / - . # ( ) ' are allowed"
                , { variant: "error" });
        }
        if (values.slots.length === 0) {

            return enqueueSnackbar('At least one working hour is required!', { variant: 'error' });
        }


        setIsBackdrop(false);
        onClose(false);
        setIsDisabled(!isDisabled);
        values.locationImage = fileList;
        values.parkingCost = parkingCost;


    };

    const handleStateChange = (event) => {
        const selectedState = event.target.value;
        setValues((prevValues) => ({
            ...prevValues,
            state: selectedState,
            city: '',
        }));

        const stateIsoCode = states.find(state => state.name === selectedState)?.isoCode;
        setCities(City.getCitiesOfState('AE', stateIsoCode));
    };

    useEffect(() => {

        if (values?.state) {

            const stateIsoCode = states.find(state => state.name === values.state)?.isoCode;
            if (stateIsoCode) {
                const citiesOfState = City.getCitiesOfState('AE', stateIsoCode);
                setCities(citiesOfState);


                if (values?.city) {
                    const cityExists = citiesOfState.some(city => city.name === values.city);
                    if (cityExists) {
                        setValues(prevValues => ({
                            ...prevValues,
                            city: values.city,
                        }));
                    }
                }
            }
        }
    }, [values.state]);


    useEffect(() => {
        setIsDialogOpen(props.isDialog);
    }, [props.isDialog]);
    const handlePopStateChange = (newState) => {
        setIsDisabled(newState);
    };
    const handlePreviewClose = () => {
        setPreviewImage('');
        setPreviewOpen(false);
        setIsDialogOpen(true);
    };
    return (
        <>
            {previewImage && (
                <Image
                    wrapperStyle={{
                        display: 'none',
                    }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => {
                            setPreviewOpen(visible);
                            if (!visible) handlePreviewClose();
                        },
                        afterOpenChange: (visible) => {
                            if (!visible) handlePreviewClose();
                        },
                    }}
                    src={previewImage}
                />
            )}
            <PopAddLocation
                isDialog={isDisabled}
                onClose={setIsDisabled}
                value={values}
                onStateChange={props.onStateChange}
                onStateChange1={handlePopStateChange}
            />
            <MDBackdrop isBackdrop={isBackdrop} />
            <Dialog open={isDialogOpen} onClose={handleClose} fullWidth={false}   // stop stretching
                PaperProps={{
                    sx: {
                        width: 1000,     //  exact width (adjust if needed)
                        borderRadius: "12px",
                    },
                }} >
                <DialogTitle style={darkMode ? { backgroundColor: "#202940", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "space-between" } : { theme, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    Basic Information
                    <IconButton aria-label="delete" onClick={handleClose} style={darkMode ? { color: "#ffffff" } : theme}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme}>
                    <MDBox pt={0} pb={0} px={3}>
                        <MDBox pt={0}>
                        </MDBox>
                        <MDBox p={1}>
                            {
                                initialLocation &&
                                <LocationPicker
                                    initialLocation={initialLocation}
                                    onLocationChange={handleLocationChange}
                                    onValueChange={handlePropChange}
                                    values={values}
                                />
                            }
                        </MDBox>

                        <MDBox p={2} component="form" role="form">
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Location Name"
                                    value={values.locationName}
                                    name="locationName"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;
                                        setErrors((prev) => ({
                                            ...prev,
                                            locationName: allowDubaiAddress(value)
                                                ? ""
                                                : "Only letters, numbers, spaces and , / - . # ( ) ' are allowed",
                                        }));
                                    }}


                                    error={Boolean(errors.locationName)}
                                    helperText={errors.locationName}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>

                            <MDBox p={1}>
                                <FormControl fullWidth>
                                    <InputLabel id="location-type-label">Location Type</InputLabel>
                                    <Select
                                        sx={{
                                            height: 50,
                                        }}
                                        labelId="location-type-label"
                                        id="location-type-select"
                                        value={values.locationType}
                                        name="locationType"
                                        onChange={handleChange}
                                        input={<OutlinedInput label="Location Type" />}
                                    >
                                        <MenuItem value="Petrol Pumps">Petrol Pumps</MenuItem>
                                        <MenuItem value="Malls">Malls</MenuItem>
                                        <MenuItem value="Highways">Highways</MenuItem>
                                        <MenuItem value="Resorts">Resorts</MenuItem>
                                        <MenuItem value="Airports">Airports</MenuItem>
                                        <MenuItem value="Hotels">Hotels</MenuItem>
                                        <MenuItem value="Parking Garages">Parking Garages</MenuItem>
                                        <MenuItem value="Office Complexes">Office Complexes</MenuItem>
                                        <MenuItem value="Supermarkets">Supermarkets</MenuItem>
                                        <MenuItem value="Train Stations">Train Stations</MenuItem>
                                        <MenuItem value="Restaurants">Restaurants</MenuItem>
                                        <MenuItem value="Residential Areas">Residential Areas</MenuItem>
                                        <MenuItem value="Parks and Recreational Areas">Parks and Recreational Areas</MenuItem>
                                        <MenuItem value="University Campuses">University Campuses</MenuItem>
                                        <MenuItem value="Convention Centers">Convention Centers</MenuItem>
                                        <MenuItem value="Stadiums and Sports Arenas">Stadiums and Sports Arenas</MenuItem>
                                        <MenuItem value="Movie Theaters">Movie Theaters</MenuItem>
                                        <MenuItem value="Hospitals">Hospitals</MenuItem>
                                        <MenuItem value="Government Buildings">Government Buildings</MenuItem>
                                        <MenuItem value="Libraries">Libraries</MenuItem>
                                        <MenuItem value="Community Centers">Community Centers</MenuItem>
                                        <MenuItem value="Beach Parking Lots">Beach Parking Lots</MenuItem>
                                        <MenuItem value="Tourist Attractions">Tourist Attractions</MenuItem>
                                        <MenuItem value="Car Dealerships">Car Dealerships</MenuItem>
                                        <MenuItem value="Metro Stations">Metro Stations</MenuItem>
                                    </Select>
                                </FormControl>
                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Address"
                                    value={values.address}
                                    name="address"
                                    multiline
                                    rows={4}
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;
                                        setErrors((prev) => ({
                                            ...prev,
                                            address: allowDubaiAddress(value)
                                                ? ""
                                                : "Only letters, numbers, spaces and , / - . # ( ) ' are allowed",
                                        }));
                                    }}

                                    error={Boolean(errors.address)}
                                    helperText={errors.address}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>
                            <MDBox p={1}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-multiple-name-label">State</InputLabel>
                                    <Select
                                        sx={{
                                            height: 50,
                                        }}
                                        labelId="demo-multiple-name-label"
                                        id="demo-multiple-name"
                                        placeholder="Select State"
                                        value={values.state}
                                        name="state"
                                        onChange={handleStateChange}
                                        input={<OutlinedInput label="State" />}
                                    >
                                        {states.map((state, index) => (
                                            <MenuItem
                                                key={index}
                                                value={state.name}                                            >
                                                {state.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </MDBox>
                            <MDBox p={1}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-multiple-name-label">City</InputLabel>
                                    <Select
                                        sx={{
                                            height: 50,
                                        }}
                                        labelId="demo-multiple-name-label"
                                        id="demo-multiple-name"
                                        placeholder="Select City"
                                        value={values.city}
                                        name="city"
                                        onChange={handleChange}
                                        input={<OutlinedInput label="City" />}
                                    >
                                        {cities.map((city, index) => (
                                            <MenuItem
                                                key={index}
                                                value={city.name}
                                            >
                                                {city.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </MDBox>
                            <MDBox p={1}>
                            </MDBox>
                            <MDBox p={1}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-multiple-name-label">Working Days</InputLabel>
                                    <Select
                                        sx={{
                                            height: 50,
                                        }}
                                        labelId="demo-multiple-name-label"
                                        id="demo-multiple-name"
                                        placeholder="Select Working Days"
                                        value={values.workingDays}
                                        name="workingDays"
                                        onChange={handleChange}
                                        input={<OutlinedInput label="Working Days" />}
                                    >
                                        <MenuItem
                                            value={"Everyday"}
                                        >
                                            Everyday
                                        </MenuItem>
                                        <MenuItem
                                            value={"Monday-Saturday"}
                                        >
                                            Monday-Saturday
                                        </MenuItem>
                                        <MenuItem
                                            value={"Monday-Friday"}
                                        >
                                            Monday-Friday
                                        </MenuItem>
                                        <MenuItem
                                            value={"Monday-Thrusday"}
                                        >
                                            Monday-Thrusday
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </MDBox>
                            <MDBox p={1}>
                                <FormLabel >Working Hours</FormLabel>
                                <Flex gap={15} style={{ flexDirection: "column", marginTop: 10 }}>
                                    {timeRanges.map((range, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                display: "flex",
                                                gap: 10,
                                                alignItems: "center",
                                            }}
                                        >
                                            <RangePicker
                                                use12Hours
                                                format="h a"
                                                value={
                                                    range.start && range.end
                                                        ? [range.start, range.end]
                                                        : null
                                                }
                                                onChange={(values) =>
                                                    handleRangeChange(index, values)
                                                }
                                                needConfirm={false}
                                            />

                                            {timeRanges.length > 1 && (
                                                <Button danger onClick={() => removeTimeSlot(index)}>
                                                    Remove
                                                </Button>
                                            )}
                                        </div>
                                    ))}

                                    <Button type="dashed" style={{ margin: 5 }} onClick={addTimeSlot}>
                                        + Add Time Slot
                                    </Button>

                                    <Button type="primary" style={{ margin: 5 }} onClick={handleWorkingHourSave}>
                                        Save Working Hours
                                    </Button>
                                </Flex>
                            </MDBox>
                            <Grid container>
                                <Grid item xs={6}>
                                    <MDBox p={1}>
                                        <FormLabel>Free Parking</FormLabel><br />
                                        <Switch
                                            checked={values.freepaid.parking}
                                            checkedChildren={<CheckOutlined />}
                                            unCheckedChildren={<CloseOutlined />}
                                            onChange={handleFreePaidChange}
                                        />
                                    </MDBox>
                                </Grid>
                                <Grid item xs={6}>
                                    <MDBox p={1}>
                                        <FormLabel>Free Charging</FormLabel><br />
                                        <Switch
                                            checked={values.freepaid.charging}
                                            checkedChildren={<CheckOutlined />}
                                            unCheckedChildren={<CloseOutlined />}
                                            onChange={handleFreePaidChangeCharging}
                                        />
                                    </MDBox>
                                </Grid>
                            </Grid>

                            {!values.freepaid.parking && (
                                <MDBox p={1}>
                                    <FormControl fullWidth
                                    >
                                        <TextField
                                            label="Parking Cost Per Hours"
                                            name="parkingCost"
                                            required
                                            variant="outlined"
                                            type="number"
                                            value={parkingCost.amount}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <FormControl variant="standard" size="small">
                                                            <Select
                                                                value={selectAfterValue}
                                                                onChange={handleCurrencyChange}
                                                            >
                                                                <MenuItem value="AED">د.إ</MenuItem>
                                                                <MenuItem value="INR">₹</MenuItem>
                                                                <MenuItem value="USD">$</MenuItem>
                                                                <MenuItem value="EUR">€</MenuItem>
                                                                <MenuItem value="GBP">£</MenuItem>
                                                                <MenuItem value="CNY">¥</MenuItem>

                                                            </Select>
                                                        </FormControl>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            onChange={handleAmountChange}
                                        />
                                    </FormControl>
                                </MDBox>
                            )}

                            <MDBox p={1}>
                                <FormLabel >Location Image</FormLabel>

                            </MDBox>

                            <MDBox p={1}>
                                <Upload
                                    customRequest={({ file, onSuccess }) => setTimeout(() => onSuccess("ok"), 0)}
                                    listType="picture-card"
                                    fileList={fileList}
                                    onPreview={handlePreview}
                                    onChange={handleUploadChange}
                                >
                                    {fileList.length >= 6 ? null : uploadButton}
                                </Upload>

                            </MDBox>
                        </MDBox>
                    </MDBox>
                </DialogContent>
                <DialogActions style={darkMode ? { backgroundColor: "#202940", justifyContent: "space-evenly", color: "#ffffff" } : { theme, justifyContent: "space-evenly" }}>
                    <MDButton variant="gradient" color={sidenavColor} onClick={reset}>
                        Reset
                    </MDButton>
                    <MDButton variant="gradient" color={sidenavColor}
                        onClick={pop}
                    >
                        NEXT
                    </MDButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default PopAddBasic;